export const aspendental = {
	PAGE_THEME_ENABLED: false,
};
